import * as actionTypes from './actionTypes';

export const updatePriceTotal = (value: number) => ({
  type: actionTypes.UPDATE_PRICE_TOTAL,
  value
});

export const setPriceTotalByChannel = (idChannel: number, data: any) => ({
  type: actionTypes.SET_PRICE_TOTAL_BY_CHANNEL,
  id: idChannel,
  data
});

export const clearPriceTotal = () => ({
  type: actionTypes.CLEAR_PRICE_TOTAL
});
